<!--
 * @Author: ZS
 * @Date: 2020-06-24 15:58:25
 * @LastEditors: ZS
 * @LastEditTime: 2020-06-24 16:10:47
 * @Description: file content
-->
<template>
<div>
   <div class="mainContent topPart">
     <v-header></v-header>
     <v-nav :index="navIndex"></v-nav>
     <div>
       <img src="../../../static/images/guidePage.png" alt="" style="width:100%">
     </div>
   </div>
</div>
</template>

<script>
import Header from '../common/Header'
import TopNav from '../common/TopNav'
import ToolBar from '../common/ToolBar'
export default {
 components: {
 'v-header': Header,
 'v-nav': TopNav,
 },
 data () {
   return {
     navIndex:3
   }
 }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/views/UserGuidance.vue